import * as React from 'react';

import {ButtonCard} from 'shells/card/button-card';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import styles from './conferencing-modal-wrapper.module.css';

type Props = {
    icon: React.ComponentType<any>;
    integrationName: string;
    onClick: () => void;
};

export function ConnectButton(props: Props) {
    const Icon = props.icon;

    return (
        <ButtonCard fitHeight={true} isFullWidth={true} onClick={props.onClick}>
            <div className={styles['button-content']}>
                <StackLegacy spacing={8} isHorizontal={true}>
                    <Icon size={17} alignCenter={true} />
                    <div>Connect with {props.integrationName}</div>
                </StackLegacy>
            </div>
        </ButtonCard>
    );
}
